import { createFileRoute } from '@tanstack/react-router'
import { useState, useEffect } from 'react'
import { guardSuperAdminOnly } from '../../lib/auth/routeGuards'
// import { API_URL } from '@/config/constants'
import { SuperAdminTour } from '@/tour/superAdminTour/globalSuperAdminTour'
// Import your components
import SuperAdminService from '@/components/adminPage/SuperAdminService'

export const Route = createFileRoute('/super_admin/')({
  beforeLoad: guardSuperAdminOnly,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <SuperAdminTour />
      <SuperAdminLayout />
    </>
  )
}

import { LayoutDashboard, CreditCard } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'


const navigation = [
  {
    name: 'Super Admin Service',
    icon: LayoutDashboard,
    component: SuperAdminService,
  },
  {
    name: 'Card Management',
    icon: CreditCard,
    component: () => (window.location.href = '/super_admin/card-management'),
  },
]

export default function SuperAdminLayout() {
  const [currentPage] = useState('Super Admin Service')

  // Tours are now managed by useTourManager hook
  // No need for manual tour triggering logic

  // Add effect to add classes to important elements for tour targeting
  useEffect(() => {
    // Find important elements and add id/classes for tour targeting
    const addClassesToElements = () => {
  // console.logSuperAdminLayout: Adding tour target classes to elements')

      // Profile button targeting - try multiple selectors
      const profileButton =
        document.querySelector('.admin-profile-menu') ||
        document.querySelector('.profile-button') ||
        document.querySelector('#admin-profile-button') ||
        document.querySelector('button.rounded-full') ||
        document.querySelector('button:has(img.rounded-full)') ||
        document.querySelector('button:has(.avatar)') ||
        document.querySelector('[data-testid="profile-menu-button"]') ||
        document.querySelector('.avatar') ||
        document.querySelector('img.rounded-full')?.parentElement

      if (profileButton) {
    // console.logSuperAdminLayout: Found profile button, adding class')
        profileButton.classList.add('super-admin-profile-menu')
        profileButton.setAttribute('data-testid', 'profile-button')
      } else {
        console.warn(
          'SuperAdminLayout: Profile button not found for tour targeting'
        )

        // If we can't find the profile button, let's add a class to the header
        const header = document.querySelector('header')
        if (header) {
          header.classList.add('super-admin-profile-menu')
          header.setAttribute('data-testid', 'header')
      // console.logSuperAdminLayout: Added class to header as fallback')
        }
      }

      // Add IDs to main content cards
      const mainCard =
        document.querySelector('main .card') ||
        document.querySelector('main > div > div') ||
        document.querySelector('main > div')

      if (mainCard) {
        mainCard.id = 'superadmin-service-card'
        mainCard.setAttribute('data-testid', 'main-card')
    // console.logSuperAdminLayout: Added ID to main service card')
      }

      // Find the reset tour button and add data-testid - using valid selectors
      try {
        // Use a more reliable approach to find the reset tour button
        const allButtons = document.querySelectorAll('button')
        let resetTourButton = null

        // Look through all buttons to find one with "Reset Tour" text
        for (let i = 0; i < allButtons.length; i++) {
          if (allButtons[i].textContent?.includes('Reset Tour')) {
            resetTourButton = allButtons[i]
            break
          }
        }

        // Also check for the data-testid
        if (!resetTourButton) {
          resetTourButton = document.querySelector(
            '[data-testid="reset-tour-button"]'
          )
        }

        if (resetTourButton) {
          resetTourButton.setAttribute('data-testid', 'reset-tour-button')
          // console.log(
          //   'SuperAdminLayout: Added data-testid to reset tour button'
          // )
        }
      } catch (error) {
        // console.error('Error finding reset tour button:', error)
      }

      // Log all important elements found for debugging
  // console.log('Tour target elements found:', {
      //   profileButton: !!profileButton,
      //   mainCard: !!mainCard,
      //   resetTourButton: !!document.querySelector(
      //     '[data-testid="reset-tour-button"]'
      //   ),
      //   mainContent: !!document.getElementById('super-admin-main-content'),
      // })
    }

    // Try multiple times to ensure elements are loaded
    setTimeout(addClassesToElements, 500)
    setTimeout(addClassesToElements, 1500)
    setTimeout(addClassesToElements, 3000)

    // Also add a mutation observer to detect when new elements are added
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          addClassesToElements()
        }
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => {
      observer.disconnect()
    }
  }, [])

  const renderContent = () => {
    const route = navigation.find((item) => item.name === currentPage)
    const Component = route?.component || SuperAdminService
    return <Component />
  }

  return (
    <div className="flex min-h-screen w-[80%] m-auto">
      {/* Main Content with ID for tour targeting */}
      <main
        id="super-admin-main-content"
        className="p-4 w-full sm:w-full md:w-10/12 lg:w-10/12 xl:w-10/12"
      >
        <Card id="superadmin-service-card">
          <CardHeader>
            <CardTitle>{currentPage}</CardTitle>
          </CardHeader>
          <CardContent>{renderContent()}</CardContent>
        </Card>
      </main>
    </div>
  )
}
